<template>
  <v-container
    justify-center
    white
    fluid
    style="font-family: 'Montserrat', sans-serif;"
    pa-0
  >
    <!-- Home Image -->
    <v-layout wrap white>
      <v-flex xs12 lg12 text-left style="overflow:hidden;max-height:100vh;">
        <v-img
          :src="require('@/assets/images/home2.png')"
          :class="{ imageAccueil: $vuetify.breakpoint.xs }"
          style="object-fit:cover;min-width:100%;max-height:100%"
        >
          <v-flex
            xs5
            pl-5
            mt-5
            :class="{ 'pt-5 mt-5 ml-5': $vuetify.breakpoint.mdAndUp }"
          >
            <div
              class="carouselTopDesktop"
              :class="{ carouselTopMobile: $vuetify.breakpoint.mdAndDown }"
            >
              <v-carousel
                cycle
                hide-delimiters
                :show-arrows="false"
                interval="5000"
                style="max-height:320px;"
              >
                <v-carousel-item>
                  <p
                    class="display-2 font-weight-bold mb-2 mt-0 pt-0 mt-5 pt-5"
                    :class="{
                      'headline mt-0 pt-0': $vuetify.breakpoint.mdAndDown
                    }"
                  >
                    {{ $t("home.title-1") }}
                  </p>
                  <p class="subtitle-1 font-weight-light mb-2 pb-2">
                    {{ $t("home.subtitle-1") }}
                  </p>
                </v-carousel-item>

                <v-carousel-item>
                  <p
                    class="display-2 font-weight-bold mb-2 mt-0 pt-0 mt-5 pt-5"
                    :class="{
                      'headline mt-0 pt-0': $vuetify.breakpoint.mdAndDown
                    }"
                  >
                    {{ $t("home.title-2") }}
                  </p>

                  <p class="subtitle-1 font-weight-light mb-2 pb-2">
                    {{ $t("home.subtitle-2") }}
                  </p>
                </v-carousel-item>
              </v-carousel>
            </div>

            <v-btn
              rounded
              depressed
              large
              light
              px-2
              class="mb-1 gradient-text text-capitalize "
              color="white"
              @click="$vuetify.goTo('#forfaits', anchorOptions)"
            >
              {{ $t("home.see-packages") }}
            </v-btn>
          </v-flex>
        </v-img>
      </v-flex>
    </v-layout>

    <!-- Icons -->
    <v-layout>
      <v-flex xs12 sm12 mb-5 pb-5>
        <v-card flat>
          <v-container fluid pa-0>
            <v-layout wrap>
              <v-img
                :src="require('@/assets/images/header-icon1.jpg')"
                class="text-center contenant icons pt-5"
                width="200"
                height="230"
              >
                <v-icon dark size="70" class="header_icons"> date_range</v-icon>
                <div class="noselect">
                  <p
                    class="white--text title font-weight-bold text-center pt-3 titre-icons"
                  >
                    {{ $t("home.headers.1.title") }}
                  </p>
                  <v-icon dark class="separator">maximize</v-icon>
                  <div class="middle">
                    <p
                      class="text white--text caption font-weight-light text-center pt-0"
                    >
                      {{ $t("home.headers.1.subtitle") }}
                    </p>
                  </div>
                </div>
              </v-img>

              <v-img
                :src="require('@/assets/images/header-icon4.jpg')"
                class="text-center contenant icons pt-5"
                width="200"
                height="230"
              >
                <v-icon dark size="70" class="header_icons"> how_to_reg</v-icon>
                <div class="noselect">
                  <p
                    class="white--text title font-weight-bold text-center pt-3 titre-icons"
                  >
                    {{ $t("home.headers.2.title") }}
                  </p>
                  <v-icon dark class="separator">maximize</v-icon>
                  <div class="middle">
                    <p
                      class="text white--text caption font-weight-light text-center pt-0"
                    >
                      {{ $t("home.headers.2.subtitle") }}
                    </p>
                  </div>
                </div>
              </v-img>

              <v-img
                :src="require('@/assets/images/header-icon2.jpg')"
                class="text-center contenant icons pt-5"
                width="200"
                height="230"
              >
                <v-icon dark size="70" class="header_icons">
                  credit_card</v-icon
                >
                <div class="noselect">
                  <p
                    class="white--text title font-weight-bold text-center pt-3 titre-icons"
                  >
                    {{ $t("home.headers.3.title") }}
                  </p>
                  <v-icon dark class="separator">maximize</v-icon>
                  <div class="middle">
                    <p
                      class="text white--text caption font-weight-light text-center pt-0"
                    >
                      {{ $t("home.headers.3.subtitle") }}
                    </p>
                  </div>
                </div>
              </v-img>

              <v-img
                :src="require('@/assets/images/header-icon5.jpg')"
                class="text-center contenant icons pt-5"
                width="200"
                height="230"
              >
                <v-icon dark size="70" class="header_icons"> face</v-icon>
                <div class="noselect">
                  <p
                    class="white--text title font-weight-bold text-center pt-3 titre-icons"
                  >
                    {{ $t("home.headers.4.title") }}
                  </p>
                  <v-icon dark class="separator">maximize</v-icon>
                  <div class="middle">
                    <p
                      class="text white--text caption font-weight-light text-center pt-0"
                    >
                      {{ $t("home.headers.4.subtitle") }}
                    </p>
                  </div>
                </div>
              </v-img>

              <v-img
                :src="require('@/assets/images/header-icon3.jpg')"
                class="text-center contenant icons pt-5"
                width="200"
                height="230"
              >
                <v-icon dark size="70" class="header_icons"> done_all</v-icon>
                <div class="noselect">
                  <p
                    class="white--text title font-weight-bold text-center pt-3 titre-icons"
                  >
                    {{ $t("home.headers.5.title") }}
                  </p>
                  <v-icon dark class="separator">maximize</v-icon>
                  <div class="middle">
                    <p
                      class="text white--text caption font-weight-light text-center pt-0"
                    >
                      {{ $t("home.headers.5.subtitle") }}
                    </p>
                  </div>
                </div>
              </v-img>

              <template v-slot:placeholder>
                <v-layout fill-height align-center justify-center ma-0>
                </v-layout>
              </template>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>

    <div width="900px">
      <p>&nbsp;<br /><br /></p>
    </div>

    <!-- Private classes -->

    <!-- Private classes title -->
    <v-layout id="forfaits" warp justify-center mt-5 pt-5>
      <v-flex xs10 mt-5>
        <p class="display-2 font-weight-thin text-center mb-1">
          {{ $t("home.packages.title") }}
        </p>

        <p class="body-2 font-weight-light mb-5 text-center">
          {{ $t("home.packages.subtitle") }}
        </p>

        <p class="body-1 font-weight-bold mb-2 text-center">
          {{ $t("home.packages.private.title") }}
        </p>
      </v-flex>
    </v-layout>

    <!-- Private classes cards (Mobile) -->
    <v-layout wrap justify-center mt-3>
      <v-carousel hide-delimiters class="d-md-none">
        <v-carousel-item :src="require('@/assets/images/carousel1.jpg')">
          <!-- 1st Panel -->
          <v-flex xs12 lg12 text-center>
            <v-card
              flat
              class="mb-5 box white--text"
              color="rgba(255, 255, 255 , 0)"
            >
              <v-card-text>
                <p class="subheading font-weight-light text-center mt-5 pt-5">
                  {{ $t("home.packages.private.option-1.title") }}
                </p>
                <p
                  class="display-2 font-weight-thin text-center mt-5 pt-3 white--text"
                >
                  {{ $t("home.packages.private.option-1.price") }}
                </p>
              </v-card-text>
              <v-card-text
                v-show="Points1"
                v-if="!showPanel1"
                justify-center
                text-center
                class="white--text caption"
              >
                <p>{{ $t("home.packages.private.option-1.line-1") }}</p>
                <p>{{ $t("home.packages.private.option-1.line-2") }}</p>
                <p>{{ $t("home.packages.private.option-1.line-3") }}</p>
                <p>{{ $t("home.packages.private.option-1.line-4") }}</p>
                <p>{{ $t("home.packages.private.option-1.line-5") }}</p>
              </v-card-text>

              <v-slide-y-transition>
                <v-card v-show="showPanel1" flat color="rgb(255,255,255,0)">
                  <div>
                    <p>&nbsp;<br /><br /></p>
                  </div>
                  <v-card-text
                    class="pb-4 pt-0 mb-5 px-5 white--text caption"
                    style="opacity:0.9;"
                  >
                    {{ $t("home.packages.private.option-1.details") }}
                  </v-card-text>
                  <div>
                    <p>&nbsp;<br /><br /></p>
                  </div>
                </v-card>
              </v-slide-y-transition>

              <v-btn
                dark
                small
                depressed
                large
                rounded
                outlined
                color="white"
                class="caption mb-5 font-weight-black text-capitalize"
                @click="showPanel1 = !showPanel1"
                >{{
                  showPanel1 ? $t("home.buttons.hide") : $t("home.buttons.more")
                }}</v-btn
              >
            </v-card>
          </v-flex>
        </v-carousel-item>

        <v-carousel-item :src="require('@/assets/images/carousel2.jpg')">
          <!-- 2nd Panel -->
          <v-flex xs12 lg12 text-center>
            <v-card
              flat
              class="mb-5 box white--text"
              color="rgba(255, 255, 255 , 0)"
            >
              <v-card-text>
                <p class="subheading font-weight-light text-center mt-5 pt-5">
                  {{ $t("home.packages.private.option-2.title") }}
                </p>
                <p
                  class="display-2 font-weight-thin text-center mt-5 pt-3 white--text"
                >
                  {{ $t("home.packages.private.option-2.price") }}
                </p>
              </v-card-text>
              <v-card-text
                v-show="Points2"
                v-if="!showPanel2"
                justify-center
                text-center
                class="white--text caption"
              >
                <p>{{ $t("home.packages.private.option-2.line-1") }}</p>
                <p>{{ $t("home.packages.private.option-2.line-2") }}</p>
                <p>{{ $t("home.packages.private.option-2.line-3") }}</p>
                <p>{{ $t("home.packages.private.option-2.line-4") }}</p>
                <p>{{ $t("home.packages.private.option-2.line-5") }}</p>
              </v-card-text>

              <v-slide-y-transition>
                <v-card v-show="showPanel2" flat color="rgb(255,255,255,0)">
                  <div>
                    <p>&nbsp;<br /><br /></p>
                  </div>
                  <v-card-text
                    class="pb-4 pt-0 mb-5 px-5 white--text caption"
                    style="opacity:0.9;"
                  >
                    {{ $t("home.packages.private.option-2.details") }}
                  </v-card-text>
                  <div>
                    <p>&nbsp;<br /><br /></p>
                  </div>
                </v-card>
              </v-slide-y-transition>

              <v-btn
                dark
                small
                depressed
                large
                rounded
                outlined
                color="white"
                class="caption mb-5 font-weight-black text-capitalize"
                @click="showPanel2 = !showPanel2"
                >{{
                  showPanel2 ? $t("home.buttons.hide") : $t("home.buttons.more")
                }}
              </v-btn>
            </v-card>
          </v-flex>
        </v-carousel-item>

        <v-carousel-item :src="require('@/assets/images/carousel3.jpg')">
          <!-- 3rd Panel -->
          <v-flex xs12 lg12 text-center>
            <v-card
              flat
              class="mb-5 box white--text"
              color="rgba(255, 255, 255 , 0)"
            >
              <v-card-text>
                <p class="subheading font-weight-light text-center mt-5 pt-5">
                  {{ $t("home.packages.private.option-3.title") }}
                </p>
                <p
                  class="display-2 font-weight-thin text-center mt-5 pt-3 white--text"
                >
                  {{ $t("home.packages.private.option-3.price") }}
                </p>
              </v-card-text>
              <v-card-text
                v-show="Points3"
                v-if="!showPanel3"
                justify-center
                text-center
                class="white--text caption"
              >
                <p>{{ $t("home.packages.private.option-3.line-1") }}</p>
                <p>{{ $t("home.packages.private.option-3.line-2") }}</p>
                <p>{{ $t("home.packages.private.option-3.line-3") }}</p>
                <p>{{ $t("home.packages.private.option-3.line-4") }}</p>
                <p>{{ $t("home.packages.private.option-3.line-5") }}</p>
              </v-card-text>

              <v-slide-y-transition>
                <v-card v-show="showPanel3" flat color="rgb(255,255,255,0)">
                  <div>
                    <p>&nbsp;<br /><br /></p>
                  </div>
                  <v-card-text
                    class="pb-4 pt-0 mb-5 px-5 white--text caption"
                    style="opacity:0.9;"
                  >
                    {{ $t("home.packages.private.option-3.details") }}
                  </v-card-text>
                  <div>
                    <p>&nbsp;<br /><br /></p>
                  </div>
                </v-card>
              </v-slide-y-transition>

              <v-btn
                dark
                small
                depressed
                large
                rounded
                outlined
                color="white"
                class="caption mb-5 font-weight-black text-capitalize"
                @click="showPanel3 = !showPanel3"
                >{{
                  showPanel3 ? $t("home.buttons.hide") : $t("home.buttons.more")
                }}</v-btn
              >
            </v-card>
          </v-flex>
        </v-carousel-item>
      </v-carousel>
    </v-layout>

    <!-- Private classes cards (Desktop) -->
    <v-layout wrap justify-center>
      <!-- 1st Panel -->
      <v-flex lg3 md3 text-center class="d-none d-md-block">
        <v-img
          :src="require('@/assets/images/carousel1.jpg')"
          style="object-fit:cover;max-height:488px"
        >
          <v-card
            flat
            class="mb-5 box white--text"
            color="rgba(255, 255, 255 , 0)"
          >
            <v-card-text>
              <p
                class="subheading font-weight-light text-center mt-5 pt-5 grey--text"
              >
                {{ $t("home.packages.private.option-1.title") }}
              </p>
              <p
                class="display-2 font-weight-thin text-center mt-5 pt-3 white--text"
              >
                {{ $t("home.packages.private.option-1.price") }}
              </p>
            </v-card-text>
            <v-card-text
              v-show="Points1"
              v-if="!showPanel1"
              justify-center
              text-center
              class="white--text caption"
            >
              <p>{{ $t("home.packages.private.option-1.line-1") }}</p>
              <p>{{ $t("home.packages.private.option-1.line-2") }}</p>
              <p>{{ $t("home.packages.private.option-1.line-3") }}</p>
              <p>{{ $t("home.packages.private.option-1.line-4") }}</p>
              <p>{{ $t("home.packages.private.option-1.line-5") }}</p>
            </v-card-text>

            <v-slide-y-transition>
              <v-card v-show="showPanel1" flat color="rgb(255,255,255,0)">
                <div>
                  <p>&nbsp;<br /><br /></p>
                </div>
                <v-card-text
                  class="pb-4 pt-0 mb-5 white--text caption"
                  style="opacity:0.9;"
                >
                  {{ $t("home.packages.private.option-1.details") }}
                </v-card-text>
                <div>
                  <p>&nbsp;<br /><br /></p>
                </div>
              </v-card>
            </v-slide-y-transition>

            <v-btn
              dark
              small
              depressed
              large
              rounded
              outlined
              color="white"
              class="caption mb-5 font-weight-black text-capitalize"
              @click="showPanel1 = !showPanel1"
              >{{
                showPanel1 ? $t("home.buttons.hide") : $t("home.buttons.more")
              }}</v-btn
            >
          </v-card>
        </v-img>
      </v-flex>

      <!-- 2nd Panel -->
      <v-flex lg3 md3 text-center class="d-none d-md-block mx-5">
        <v-img
          :src="require('@/assets/images/carousel2.jpg')"
          style="object-fit:cover;max-height:488px"
        >
          <v-card
            flat
            class="mb-5 box white--text"
            color="rgba(255, 255, 255 , 0)"
          >
            <v-card-text>
              <p
                class="subheading font-weight-thin text-center mt-5 pt-5 white--text"
                style="opacity:0.7;"
              >
                {{ $t("home.packages.private.option-2.title") }}
              </p>
              <p
                class="display-2 font-weight-thin text-center mt-5 pt-3 white--text"
              >
                {{ $t("home.packages.private.option-2.price") }}
              </p>
            </v-card-text>
            <v-card-text
              v-show="Points2"
              v-if="!showPanel2"
              justify-center
              text-center
              class="white--text caption"
            >
              <p>{{ $t("home.packages.private.option-2.line-1") }}</p>
              <p>{{ $t("home.packages.private.option-2.line-2") }}</p>
              <p>{{ $t("home.packages.private.option-2.line-3") }}</p>
              <p>{{ $t("home.packages.private.option-2.line-4") }}</p>
              <p>{{ $t("home.packages.private.option-2.line-5") }}</p>
            </v-card-text>

            <v-slide-y-transition>
              <v-card v-show="showPanel2" flat color="rgb(255,255,255,0)">
                <div>
                  <p>&nbsp;<br /><br /></p>
                </div>
                <v-card-text
                  class="pb-4 pt-0 mb-5 white--text caption"
                  style="opacity:0.9;"
                >
                  {{ $t("home.packages.private.option-2.details") }}
                </v-card-text>
                <div>
                  <p>&nbsp;<br /><br /></p>
                </div>
              </v-card>
            </v-slide-y-transition>

            <v-btn
              dark
              small
              depressed
              large
              rounded
              outlined
              color="white"
              class="caption mb-5 font-weight-black text-capitalize"
              @click="showPanel2 = !showPanel2"
              >{{
                showPanel2 ? $t("home.buttons.hide") : $t("home.buttons.more")
              }}</v-btn
            >
          </v-card>
        </v-img>
      </v-flex>

      <!-- 3rd Panel -->
      <v-flex lg3 md3 text-center class="d-none d-md-block">
        <v-img
          :src="require('@/assets/images/carousel3.jpg')"
          style="object-fit:cover;max-height:488px"
        >
          <v-card
            flat
            class="mb-5 box white--text"
            color="rgba(255, 255, 255 , 0)"
          >
            <v-card-text>
              <p
                class="subheading font-weight-light text-center mt-5 pt-5 grey--text"
              >
                {{ $t("home.packages.private.option-3.title") }}
              </p>
              <p
                class="display-2 font-weight-thin text-center mt-5 pt-3 white--text"
              >
                {{ $t("home.packages.private.option-3.price") }}
              </p>
            </v-card-text>
            <v-card-text
              v-show="Points3"
              v-if="!showPanel3"
              justify-center
              text-center
              class="white--text caption"
            >
              <p>{{ $t("home.packages.private.option-3.line-1") }}</p>
              <p>{{ $t("home.packages.private.option-3.line-2") }}</p>
              <p>{{ $t("home.packages.private.option-3.line-3") }}</p>
              <p>{{ $t("home.packages.private.option-3.line-4") }}</p>
              <p>{{ $t("home.packages.private.option-3.line-5") }}</p>
            </v-card-text>

            <v-slide-y-transition>
              <v-card v-show="showPanel3" flat color="rgb(255,255,255,0)">
                <div>
                  <p>&nbsp;<br /><br /></p>
                </div>
                <v-card-text
                  class="pb-4 pt-0 mb-5 white--text caption"
                  style="opacity:0.9;"
                >
                  {{ $t("home.packages.private.option-3.details") }}
                </v-card-text>
                <div>
                  <p>&nbsp;<br /><br /></p>
                </div>
              </v-card>
            </v-slide-y-transition>

            <v-btn
              dark
              small
              depressed
              large
              rounded
              outlined
              color="white"
              class="caption mb-5 font-weight-black text-capitalize"
              @click="showPanel3 = !showPanel3"
              >{{
                showPanel3 ? $t("home.buttons.hide") : $t("home.buttons.more")
              }}</v-btn
            >
          </v-card>
        </v-img>
      </v-flex>
    </v-layout>

    <!-- Red Reminder -->
    <v-layout
      row
      wrap
      justify-center
      align-center
      class="gradient1"
      py-4
      mb-5
      px-0
      mx-0
    >
      <!-- Text -->
      <v-flex xs12 md2>
        <v-card
          class="text-center"
          flat
          color="rgba(255, 255, 255 , 0)"
          height="50px"
          :class="{ 'mt-5': $vuetify.breakpoint.xs }"
        >
          <img src="@/assets/images/star.png" alt="star" height="90%" />
        </v-card>
      </v-flex>
      <v-flex xs12 md4>
        <v-card
          flat
          color="rgba(255, 255, 255 , 0)"
          :class="{ 'mt-3': $vuetify.breakpoint.xs }"
        >
          <v-card-text class="text-center white--text mt-1 caption">
            {{ $t("home.promotion.invitation") }}
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 md2>
        <v-card
          flat
          color="rgba(255, 255, 255 , 0)"
          class="white--text text-center mt-1"
          :class="{ 'mt-3': $vuetify.breakpoint.xs }"
        >
          <v-btn
            small
            depressed
            text
            outlined
            dark
            large
            rounded
            color="white"
            class="caption font-weight-black"
            :class="{ 'mb-5': $vuetify.breakpoint.xs }"
            @click="$vuetify.goTo('#promotion', anchorOptions)"
            >{{ $t("home.promotion.button") }}</v-btn
          >
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Group classes -->

    <!-- Group classes title -->
    <v-layout warp justify-center pt-2>
      <v-flex xs10 mt-5>
        <p
          class="body-1 font-weight-bold mb-0 text-center"
          :class="{ 'mb-2': $vuetify.breakpoint.mdAndDown }"
        >
          {{ $t("home.packages.group.title") }}
        </p>
      </v-flex>
    </v-layout>

    <!-- Group classes cards (Mobile) -->
    <v-layout wrap justify-center my-3>
      <v-carousel hide-delimiters class="d-md-none">
        <v-carousel-item :src="require('@/assets/images/carousel4.jpg')">
          <!-- 1st Panel -->
          <v-flex xs12 lg12 text-center>
            <v-card
              flat
              class="mb-5 box white--text"
              color="rgba(255, 255, 255 , 0)"
            >
              <v-card-text>
                <p class="subheading font-weight-light text-center mt-5 pt-5">
                  {{ $t("home.packages.group.option-1.title") }}
                </p>
                <p
                  class="display-2 font-weight-thin text-center mt-5 pt-3 white--text"
                >
                  {{ $t("home.packages.group.option-1.price") }}
                </p>
              </v-card-text>
              <v-card-text
                v-show="Points4"
                v-if="!showPanel4"
                justify-center
                text-center
                class="white--text caption"
              >
                <p>{{ $t("home.packages.group.option-1.line-1") }}</p>
                <p>{{ $t("home.packages.group.option-1.line-2") }}</p>
                <p>{{ $t("home.packages.group.option-1.line-3") }}</p>
                <p>{{ $t("home.packages.group.option-1.line-4") }}</p>
                <p>{{ $t("home.packages.group.option-1.line-5") }}</p>
              </v-card-text>

              <v-slide-y-transition>
                <v-card v-show="showPanel4" flat color="rgb(255,255,255,0)">
                  <div>
                    <p>&nbsp;<br /><br /></p>
                  </div>
                  <v-card-text
                    class="pb-4 pt-0 mb-5 px-5 white--text caption"
                    style="opacity:0.9;"
                  >
                    {{ $t("home.packages.group.option-1.details") }}
                  </v-card-text>
                  <div>
                    <p>&nbsp;<br /><br /></p>
                  </div>
                </v-card>
              </v-slide-y-transition>

              <v-btn
                dark
                small
                depressed
                large
                rounded
                outlined
                color="white"
                class="caption mb-5 font-weight-black text-capitalize"
                @click="showPanel4 = !showPanel4"
                >{{
                  showPanel4 ? $t("home.buttons.hide") : $t("home.buttons.more")
                }}</v-btn
              >
            </v-card>
          </v-flex>
        </v-carousel-item>

        <v-carousel-item :src="require('@/assets/images/carousel5.jpg')">
          <!-- 2nd Panel -->
          <v-flex xs12 lg12 text-center>
            <v-card
              flat
              class="mb-5 box white--text"
              color="rgba(255, 255, 255 , 0)"
            >
              <v-card-text>
                <p class="subheading font-weight-light text-center mt-5 pt-5">
                  {{ $t("home.packages.group.option-2.title") }}
                </p>
                <p
                  class="display-2 font-weight-thin text-center mt-5 pt-3 white--text"
                >
                  {{ $t("home.packages.group.option-2.price") }}
                </p>
              </v-card-text>
              <v-card-text
                v-show="Points5"
                v-if="!showPanel5"
                justify-center
                text-center
                class="white--text caption"
              >
                <p>{{ $t("home.packages.group.option-2.line-1") }}</p>
                <p>{{ $t("home.packages.group.option-2.line-2") }}</p>
                <p>{{ $t("home.packages.group.option-2.line-3") }}</p>
                <p>{{ $t("home.packages.group.option-2.line-4") }}</p>
                <p>{{ $t("home.packages.group.option-2.line-5") }}</p>
              </v-card-text>

              <v-slide-y-transition>
                <v-card v-show="showPanel5" flat color="rgb(255,255,255,0)">
                  <div>
                    <p>&nbsp;<br /><br /></p>
                  </div>
                  <v-card-text
                    class="pb-4 pt-0 mb-5 px-5 white--text caption"
                    style="opacity:0.9;"
                  >
                    {{ $t("home.packages.group.option-2.details") }}
                  </v-card-text>
                  <div>
                    <p>&nbsp;<br /><br /></p>
                  </div>
                </v-card>
              </v-slide-y-transition>

              <v-btn
                dark
                small
                depressed
                large
                rounded
                outlined
                color="white"
                class="caption mb-5 font-weight-black text-capitalize"
                @click="showPanel5 = !showPanel5"
                >{{
                  showPanel5 ? $t("home.buttons.hide") : $t("home.buttons.more")
                }}</v-btn
              >
            </v-card>
          </v-flex>
        </v-carousel-item>

        <v-carousel-item :src="require('@/assets/images/carousel6.jpg')">
          <!-- 3rd Panel -->
          <v-flex xs12 lg12 text-center>
            <v-card
              flat
              class="mb-5 box white--text"
              color="rgba(255, 255, 255 , 0)"
            >
              <v-card-text>
                <p class="subheading font-weight-light text-center mt-5 pt-5">
                  {{ $t("home.packages.group.option-3.title") }}
                </p>
                <p
                  class="display-2 font-weight-thin text-center mt-5 pt-3 white--text"
                >
                  {{ $t("home.packages.group.option-3.price") }}
                </p>
              </v-card-text>
              <v-card-text
                v-show="Points6"
                v-if="!showPanel6"
                justify-center
                text-center
                class="white--text caption"
              >
                <p>{{ $t("home.packages.group.option-3.line-1") }}</p>
                <p>{{ $t("home.packages.group.option-3.line-2") }}</p>
                <p>{{ $t("home.packages.group.option-3.line-3") }}</p>
                <p>{{ $t("home.packages.group.option-3.line-4") }}</p>
                <p>{{ $t("home.packages.group.option-3.line-5") }}</p>
              </v-card-text>

              <v-slide-y-transition>
                <v-card v-show="showPanel6" flat color="rgb(255,255,255,0)">
                  <div>
                    <p>&nbsp;<br /><br /></p>
                  </div>
                  <v-card-text
                    class="pb-4 pt-0 mb-5 px-6 white--text caption"
                    style="opacity:0.9;"
                  >
                    {{ $t("home.packages.group.option-3.details") }}
                  </v-card-text>
                  <div>
                    <p>&nbsp;<br /><br /></p>
                  </div>
                </v-card>
              </v-slide-y-transition>

              <v-btn
                dark
                small
                depressed
                large
                rounded
                outlined
                color="white"
                class="caption mb-5 font-weight-black text-capitalize"
                @click="showPanel6 = !showPanel6"
                >{{
                  showPanel6 ? $t("home.buttons.hide") : $t("home.buttons.more")
                }}</v-btn
              >
            </v-card>
          </v-flex>
        </v-carousel-item>
      </v-carousel>
    </v-layout>

    <!-- Group classes cards (Desktop) -->
    <v-layout wrap justify-center>
      <!-- 1st Panel -->
      <v-flex lg3 md3 text-center class="d-none d-md-block">
        <v-img
          :src="require('@/assets/images/carousel4.jpg')"
          style="object-fit:cover;max-height:488px"
        >
          <v-card
            flat
            class="mb-5 box white--text"
            color="rgba(255, 255, 255 , 0)"
          >
            <v-card-text>
              <p
                class="subheading font-weight-light text-center mt-5 pt-5 grey--text"
              >
                {{ $t("home.packages.group.option-1.title") }}
              </p>
              <p
                class="display-2 font-weight-thin text-center mt-5 pt-3 white--text"
              >
                {{ $t("home.packages.group.option-1.price") }}
              </p>
            </v-card-text>
            <v-card-text
              v-show="Points4"
              v-if="!showPanel4"
              justify-center
              text-center
              class="white--text caption"
            >
              <p>{{ $t("home.packages.group.option-1.line-1") }}</p>
              <p>{{ $t("home.packages.group.option-1.line-2") }}</p>
              <p>{{ $t("home.packages.group.option-1.line-3") }}</p>
              <p>{{ $t("home.packages.group.option-1.line-4") }}</p>
              <p>{{ $t("home.packages.group.option-1.line-5") }}</p>
            </v-card-text>

            <v-slide-y-transition>
              <v-card v-show="showPanel4" flat color="rgb(255,255,255,0)">
                <div>
                  <p>&nbsp;<br /><br /></p>
                </div>
                <v-card-text
                  class="pb-4 pt-0 mb-5 white--text caption"
                  style="opacity:0.9;"
                >
                  {{ $t("home.packages.group.option-1.details") }}
                </v-card-text>
                <div>
                  <p>&nbsp;<br /><br /></p>
                </div>
              </v-card>
            </v-slide-y-transition>

            <v-btn
              dark
              small
              depressed
              large
              rounded
              outlined
              color="white"
              class="caption mb-5 font-weight-black text-capitalize"
              @click="showPanel4 = !showPanel4"
              >{{
                showPanel4 ? $t("home.buttons.hide") : $t("home.buttons.more")
              }}</v-btn
            >
          </v-card>
        </v-img>
      </v-flex>

      <!-- 2nd Panel -->
      <v-flex lg3 md3 text-center class="d-none d-md-block mx-5">
        <v-img
          :src="require('@/assets/images/carousel5.jpg')"
          style="object-fit:cover;max-height:488px"
        >
          <v-card
            flat
            class="mb-5 box white--text"
            color="rgba(255, 255, 255 , 0)"
          >
            <v-card-text>
              <p
                class="subheading font-weight-thin text-center mt-5 pt-5 white--text"
                style="opacity:0.7;"
              >
                {{ $t("home.packages.group.option-2.title") }}
              </p>
              <p
                class="display-2 font-weight-thin text-center mt-5 pt-3 white--text"
              >
                {{ $t("home.packages.group.option-2.price") }}
              </p>
            </v-card-text>
            <v-card-text
              v-show="Points5"
              v-if="!showPanel5"
              justify-center
              text-center
              class="white--text caption"
            >
              <p>{{ $t("home.packages.group.option-2.line-1") }}</p>
              <p>{{ $t("home.packages.group.option-2.line-2") }}</p>
              <p>{{ $t("home.packages.group.option-2.line-3") }}</p>
              <p>{{ $t("home.packages.group.option-2.line-4") }}</p>
              <p>{{ $t("home.packages.group.option-2.line-5") }}</p>
            </v-card-text>

            <v-slide-y-transition>
              <v-card v-show="showPanel5" flat color="rgb(255,255,255,0)">
                <div>
                  <p>&nbsp;<br /><br /></p>
                </div>
                <v-card-text
                  class="pb-4 pt-0 mb-5 white--text caption"
                  style="opacity:0.9;"
                >
                  {{ $t("home.packages.group.option-2.details") }}
                </v-card-text>
                <div>
                  <p>&nbsp;<br /><br /></p>
                </div>
              </v-card>
            </v-slide-y-transition>

            <v-btn
              dark
              small
              depressed
              large
              rounded
              outlined
              color="white"
              class="caption mb-5 font-weight-black text-capitalize"
              @click="showPanel5 = !showPanel5"
              >{{
                showPanel5 ? $t("home.buttons.hide") : $t("home.buttons.more")
              }}</v-btn
            >
          </v-card>
        </v-img>
      </v-flex>

      <!-- 3rd Panel -->
      <v-flex lg3 md3 text-center class="d-none d-md-block">
        <v-img
          :src="require('@/assets/images/carousel6.jpg')"
          style="object-fit:cover;max-height:488px"
        >
          <v-card
            flat
            class="mb-5 box white--text"
            color="rgba(255, 255, 255 , 0)"
          >
            <v-card-text>
              <p
                class="subheading font-weight-light text-center mt-5 pt-5 grey--text"
              >
                {{ $t("home.packages.group.option-3.title") }}
              </p>
              <p
                class="display-2 font-weight-thin text-center mt-5 pt-3 white--text"
              >
                {{ $t("home.packages.group.option-3.price") }}
              </p>
            </v-card-text>
            <v-card-text
              v-show="Points6"
              v-if="!showPanel6"
              justify-center
              text-center
              class="white--text caption"
            >
              <p>{{ $t("home.packages.group.option-3.line-1") }}</p>
              <p>{{ $t("home.packages.group.option-3.line-2") }}</p>
              <p>{{ $t("home.packages.group.option-3.line-3") }}</p>
              <p>{{ $t("home.packages.group.option-3.line-4") }}</p>
              <p>{{ $t("home.packages.group.option-3.line-5") }}</p>
            </v-card-text>

            <v-slide-y-transition>
              <v-card v-show="showPanel6" flat color="rgb(255,255,255,0)">
                <div>
                  <p>&nbsp;<br /><br /></p>
                </div>
                <v-card-text
                  class="pb-4 pt-0 mb-5 white--text caption"
                  style="opacity:0.9;"
                >
                  {{ $t("home.packages.group.option-3.details") }}
                </v-card-text>
                <div>
                  <p><br /><br /></p>
                </div>
              </v-card>
            </v-slide-y-transition>

            <v-btn
              dark
              small
              depressed
              large
              rounded
              outlined
              color="white"
              class="caption mb-5 font-weight-black text-capitalize"
              @click="showPanel6 = !showPanel6"
              >{{
                showPanel6 ? $t("home.buttons.hide") : $t("home.buttons.more")
              }}</v-btn
            >
          </v-card>
        </v-img>
      </v-flex>
    </v-layout>

    <div width="900px">
      <p>&nbsp;<br /><br /><br /><br /></p>
    </div>

    <!-- Instruments -->

    <!-- Title -->
    <v-layout text-center pt-5 mt-5>
      <v-card-text>
        <p class="display-2 font-weight-thin mb-5">
          {{ $t("home.instruments.title") }}
        </p>
      </v-card-text>
    </v-layout>

    <!-- Gallery -->
    <v-layout justify-center class="pb-5 mb-5">
      <v-card flat width="1350px">
        <v-container
          fluid
          grid-list-sm
          justify-center
          class="pa-0 ma-0 text-center"
        >
          <!-- TODO: Get English images as well -->
          <v-layout wrap justify-center class="pa-0 ma-0 text-center">
            <v-flex xs4 justify-center class="pa-0 ma-0">
              <img src="@/assets/images/icons-1.png" width="95%" height="95%" />
            </v-flex>
            <v-flex xs4 justify-center class="pa-0 ma-0">
              <img src="@/assets/images/icons-7.png" width="95%" height="95%" />
            </v-flex>
            <v-flex xs4 justify-center class="pa-0 ma-0">
              <img src="@/assets/images/icons-8.png" width="95%" height="95%" />
            </v-flex>
            <v-flex xs4 justify-center class="pa-0 ma-0">
              <img src="@/assets/images/icons-2.png" width="95%" height="95%" />
            </v-flex>
            <v-flex xs4 justify-center class="pa-0 ma-0">
              <img src="@/assets/images/icons-4.png" width="95%" height="95%" />
            </v-flex>
            <v-flex xs4 justify-center class="pa-0 ma-0">
              <img src="@/assets/images/icons-5.png" width="95%" height="95%" />
            </v-flex>
            <v-flex xs4 justify-center class="pa-0 ma-0">
              <img src="@/assets/images/icons-3.png" width="95%" height="95%" />
            </v-flex>
            <v-flex xs4 justify-center class="pa-0 ma-0">
              <img src="@/assets/images/icons-9.png" width="95%" height="95%" />
            </v-flex>
            <v-flex xs4 justify-center class="pa-0 ma-0">
              <img src="@/assets/images/icons-6.png" width="95%" height="95%" />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-layout>

    <div width="900px">
      <p>&nbsp;<br /><br /><br /></p>
    </div>

    <v-layout id="promotion" grey lighten-4>
      <div width="900px">
        <p>&nbsp;<br /><br /><br /></p>
      </div>
    </v-layout>

    <!-- Promotions -->
    <v-layout
      class="overflow-y-auto"
      wrap
      justify-center
      text-left
      grey
      lighten-4
      py-5
      px-5
    >
      <v-flex lg4 xs12 mt-5 px-5>
        <img
          src="@/assets/images/Violon.png"
          width="500"
          style="overflow:hidden;max-width:100%"
        />
      </v-flex>

      <v-flex lg5 xs12 wrap>
        <v-card
          flat
          color="grey lighten-4"
          class="homeTile"
          :class="{ 'mx-5': $vuetify.breakpoint.mdAndDown }"
        >
          <p
            class="display-1 font-weight-light pt-5"
            :class="{ 'mt-5': $vuetify.breakpoint.lg }"
          >
            {{ $t("home.promotion.title-left") }}
            <strong>{{ $t("home.promotion.title-bold") }}</strong
            >{{ $t("home.promotion.title-right") }}
          </p>
          <p class="mb-5 body-2 pb-5" style="line-height:23px;">
            {{ $t("home.promotion.description") }}
          </p>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout grey lighten-4>
      <div width="900px">
        <p>&nbsp;<br /><br /><br /></p>
      </div>
    </v-layout>

    <!-- S'inscrire-->
    <v-layout class="overflow-y-auto" wrap justify-center text-left>
      <v-flex xs12 lg12 text-left style="overflow:hidden;max-height:55vh;">
        <v-img
          :src="require('@/assets/images/Footer.jpg')"
          :class="{ imageAccueil: $vuetify.breakpoint.xs }"
          style="object-fit:cover;min-width:100%;max-height:100%"
        >
          <v-card
            flat
            style="opacity:0.9;"
            color="rgba(255,255,255, 0)"
            class="text-center pt-5 pb-5"
            :class="{ 'mx-5': $vuetify.breakpoint.mdAndDown }"
          >
            <p class="title font-weight-light pt-5 mb-5 mt-5 white--text">
              {{ $t("home.about.headline") }}
            </p>

            <div>
              <v-dialog v-model="dialog1" width="600px">
                <template v-slot:activator="{ on }">
                  <v-btn
                    rounded
                    depressed
                    large
                    light
                    class="mb-1 gradient-text text-capitalize "
                    color="white"
                    mt-5
                    v-on="on"
                  >
                    {{ $t("home.about.inscription.button") }}
                  </v-btn>
                </template>

                <v-card class="text-left">
                  <v-card-text class="pt-5" style="opacity:1;">
                    {{ $t("home.about.inscription.details") }}
                    <br /><br />
                    <v-icon color="red lighten-1" size="35">home</v-icon>
                    {{ $t("home.about.inscription.address") }}<br />
                    <br /><v-icon color="red lighten-1" size="35"
                      >stay_current_portrait</v-icon
                    >
                    &nbsp;01-450-349-9666<br />
                    <v-btn
                      color="red lighten-1"
                      class="mt-5"
                      text
                      @click="dialog1 = false"
                      >{{ $t("home.buttons.close") }}</v-btn
                    >
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>

            <div>
              <v-dialog v-model="dialog" width="600px">
                <template v-slot:activator="{ on }">
                  <v-btn
                    text
                    class="caption mt-0 pt-0 mb-5 text-capitalize"
                    style="color:white;"
                    dark
                    v-on="on"
                    ><u>{{ $t("home.about.rules.link") }}</u></v-btn
                  >
                </template>

                <v-card>
                  <v-card-title>
                    <span class="headline">{{
                      $t("home.about.rules.title")
                    }}</span>
                  </v-card-title>

                  <v-card-text>
                    <strong>{{
                      $t("home.about.rules.classes.headline")
                    }}</strong
                    ><br />
                    {{ $t("home.about.rules.classes.line-1") }}<br />
                    {{ $t("home.about.rules.classes.line-2") }}<br />
                    {{ $t("home.about.rules.classes.line-3") }}<br />
                    {{ $t("home.about.rules.classes.line-4") }}<br />
                    <br />
                    <strong>{{
                      $t("home.about.rules.student-absence.headline")
                    }}</strong
                    ><br />
                    {{ $t("home.about.rules.student-absence.line-1") }}<br />
                    <br />
                    <strong>{{
                      $t("home.about.rules.promotion.headline")
                    }}</strong
                    ><br />
                    {{ $t("home.about.rules.promotion.line-1") }}<br />
                    <br />
                    <strong>{{
                      $t("home.about.rules.teacher-absence.headline")
                    }}</strong
                    ><br />
                    {{ $t("home.about.rules.teacher-absence.line-1") }}<br />
                    <br />
                    <strong>{{ $t("home.about.rules.fees.headline") }}</strong
                    ><br />
                    {{ $t("home.about.rules.fees.line-1") }}<br />
                    <br />
                    <strong>{{
                      $t("home.about.rules.warning.headline")
                    }}</strong
                    ><br />
                    {{ $t("home.about.rules.warning.line-1") }}<br />

                    <v-btn
                      color="red lighten-1"
                      class="mt-3"
                      text
                      @click="dialog = false"
                      >{{ $t("home.buttons.close") }}</v-btn
                    >
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <div width="600px">
              <p>&nbsp;</p>
            </div>
          </v-card>
        </v-img>
      </v-flex>
    </v-layout>

    <!-- Instruments & Footer-->
    <v-layout justify-center class="gradient1" text-center wrap>
      <v-flex xs11 style="opacity:0.8;">
        <v-card
          flat
          color="rgba(255, 255, 255 , 0)"
          width="1900px"
          class="py-5"
        >
          <div class="caption white--text px-3" style="display:inline;">
            {{ $t("home.instruments.elec-guitar") }}
          </div>

          <div class="caption white--text px-3" style="display:inline;">
            {{ $t("home.instruments.ac-guitar") }}
          </div>

          <div class="caption white--text px-3" style="display:inline;">
            {{ $t("home.instruments.class-guitar") }}
          </div>

          <div class="caption white--text px-3" style="display:inline;">
            {{ $t("home.instruments.class-piano") }}
          </div>

          <div class="caption white--text px-3" style="display:inline;">
            {{ $t("home.instruments.jazz-piano") }}
          </div>

          <div class="caption white--text px-3" style="display:inline;">
            {{ $t("home.instruments.pop-piano") }}
          </div>

          <div class="caption white--text px-3" style="display:inline;">
            {{ $t("home.instruments.class-singing") }}
          </div>

          <div class="caption white--text px-3" style="display:inline;">
            {{ $t("home.instruments.pop-singing") }}
          </div>

          <div class="caption white--text px-3" style="display:inline;">
            {{ $t("home.instruments.jazz-singing") }}
          </div>

          <div class="caption white--text px-3" style="display:inline;">
            {{ $t("home.instruments.drum") }}
          </div>

          <div class="caption white--text px-3" style="display:inline;">
            {{ $t("home.instruments.violin") }}
          </div>

          <div class="caption white--text px-3" style="display:inline;">
            {{ $t("home.instruments.ukulele") }}
          </div>

          <div class="caption white--text px-3" style="display:inline;">
            {{ $t("home.instruments.bass") }}
          </div>

          <div class="caption white--text px-3" style="display:inline;">
            {{ $t("home.instruments.sax") }}
          </div>

          <div class="caption white--text px-3" style="display:inline;">
            {{ $t("home.instruments.more") }}
          </div>
        </v-card>
      </v-flex>

      <v-flex lg5 xs7 md7 pt-5>
        <v-divider dark></v-divider>
        <p class="caption font-weight-medium dark my-5 white--text">
          École Musique Dépôt © 2020
        </p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    showPanel1: false,
    showPanel2: false,
    showPanel3: false,
    showPanel4: false,
    showPanel5: false,
    showPanel6: false,
    showContact: false,
    showInstruments: false,
    Points1: true,
    Points2: true,
    Points3: true,
    Points4: true,
    Points5: true,
    Points6: true,
    dialog: false,
    dialog1: false,
    anchorOptions: {
      duration: 1000,
      offset: 3,
      easing: "easeInOutCubic"
    }
  })
};
</script>

<style scoped>
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Opera and Firefox */
}

.box {
  border-radius: 20px;
}

.box1 {
  background: rgb(238, 174, 202);
  background: linear-gradient(
    50deg,
    rgb(214, 110, 124) 0%,
    rgb(132, 175, 169) 100%
  );
  opacity: 0.9;
}

.v-window__prev,
.v-window__next {
  background-color: red;
}

.table-button-opacity {
  opacity: 1;
}

.hover12 {
  background: #f76c6c;
}
.hover12 img {
  opacity: 1;
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
}
.hover12:hover img {
  opacity: 0.5;
}

.centered {
  margin-right: 50%;
  margin-left: 50%;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}

.icons {
  opacity: 1;
  transition: 0.5s ease;
}

.icons:hover {
  opacity: 0.8;
}

.middle {
  transition: 1s ease;
  opacity: 0;
  text-align: center;
}

.contenant:hover .middle {
  opacity: 1;
}

.contenant:hover .titre-icons {
  margin-top: -20px;
}

.contenant:hover .separator {
  opacity: 1;
}

.text {
  color: white;
  font-size: 16px;
  padding: 16px 32px;
}

.separator {
  opacity: 0;
  transition: 0.5s ease;
}

.contenant:hover .header_icons {
  margin-bottom: -65px;
  opacity: 0;
}

.header_icons {
  padding-top: 45px;
}

.header_icons:hover {
  padding-top: -20px;
}

.imageAccueil {
  height: 900px;
}

.homeTile {
  opacity: 0.7;
}

.homeTile .homeText {
  opacity: 1;
}

.bigTitle {
  font-size: 4rem;
  line-height: 4.5rem;
  letter-spacing: 0.03em;
  font-weight: 200;
}

.bigTitleMobile {
  font-size: 2.7rem;
  line-height: 3.2rem;
  letter-spacing: 0.02em;
  font-weight: 300;
}

.smallTitle {
  line-height: 1rem;
  letter-spacing: 0em;
  font-weight: 200;
}

.smallTitleMobile {
  font-size: 1.08rem;
  line-height: 1rem;
  letter-spacing: 0.03em;
  font-weight: 300;
}

.gradient1 {
  background-color: #fd217c;
  background-image: linear-gradient(19deg, #fd217c 0%, #ff4a21 100%);
}

.gradient2 {
  background-color: #161616;
}

.gradient-text {
  background-color: #fd217c;
  background-image: linear-gradient(19deg, #fd217c 0%, #ff4a21 100%);
  font-size: 0.9rem;
  letter-spacing: 0em;
  font-weight: bolder;
  color: white;
}

.footer {
  height: 200px;
}

.carouselTopDesktop {
  height: 200px;
}

.carouselTopMobile {
  height: 320px;
}
</style>
